import Vector from "victor";
import { SetAttributeOperation } from "../operations/SetAttributeOperation";
import { TextShape2 } from "../text/TextShape";
import TextShapeDOMRepresentation from "../text/TextShapeDOMRepresentation";
import { AttributeKey } from "../types/attributes";
import WhiteboardControllerInterface from "../types/WhiteboardControllerInterface";
import { DragHandle } from "./DragHandle";

export class TextMaxWidthDragHandle extends DragHandle {
  originalMaxWidth: number | null = null;

  get textShapeDR(): TextShapeDOMRepresentation {
    return this.shapeDR as TextShapeDOMRepresentation;
  }

  get shape(): TextShape2 {
    return this.shapeDR.shape as unknown as TextShape2;
  }

  getLocalPoint(): Vector {
    return new Vector(
      this.textShapeDR.boundingRect.width,
      this.textShapeDR.boundingRect.height / 2
    );
  }

  computeMaxWidth(
    screenPoint: Vector,
    wb: WhiteboardControllerInterface
  ): number {
    const worldPoint = wb.camera.convertScreenToWorld(screenPoint);
    const minWidth = 44;
    return Math.max(
      minWidth,
      worldPoint.x - this.textShapeDR.boundingRect.minX
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onPointerDown(screenPoint: Vector, wb: WhiteboardControllerInterface): void {
    this.originalMaxWidth = this.textShapeDR.boundingRect.width;
  }

  onPointerDrag(screenPoint: Vector, wb: WhiteboardControllerInterface): void {
    wb.shapeStore.sendUpsertSingleLive(this.shapeDR.id, {
      key: AttributeKey.MaxWidth,
      value: this.computeMaxWidth(screenPoint, wb),
    });
  }

  onPointerUp(screenPoint: Vector, wb: WhiteboardControllerInterface): void {
    const op = new SetAttributeOperation(
      [this.shapeDR.id],
      AttributeKey.MaxWidth,
      this.originalMaxWidth,
      this.computeMaxWidth(screenPoint, wb)
    );
    wb.applyOperation(op);
  }
}
